export const stateKeys = {
  showLightbox: 'showLightbox',
  images: 'images',
  imageIndexes: 'imageIndexes',
  selectedImageIndex: 'selectedImageIndex',
};
